import { JsonProductCategory, isValidJsonProductCategory } from "../json-data-types/JsonProductCategory";
import { CachedVariable } from '@lexriver/cache'
import { Settings } from "../../Settings";
import { RequestMaker } from './RequestMaker'
import { GlobalUser } from "../GlobalUser";
import { EnumDisplayPrice } from "../enums/EnumDisplayPrice";


const filename = 'ServerCategories'

export module ServerCategories {

    const categoriesCache = new CachedVariable<JsonProductCategory[]>({
        maxAgeInMilliseconds: 60*1000,
        updateFunction: async () => {
            return await RequestMaker.sendWebsocketJsonRequestAsync<JsonProductCategory[]>({query:'categories'}, filename)    
        },
        useLazyUpdate: true
    })

    export async function clearCacheAsync(){
        await categoriesCache.clearCacheAsync()
    }

    export async function getAllCategoriesAsync() {
        //return await RequestMaker.sendWebsocketJsonRequestAsync<JsonProductCategory[]>({query:'categories'}, filename)
        return await categoriesCache.getAsync()
    }

    export async function getTopLevelCategoriesAsync(){
        return await getAllSubcategoriesAsync()
    }

    export async function getAllSubcategoriesAsync(parentCategoryId?:number){
        const all = await getAllCategoriesAsync()
        // if(!parentCategoryId){
        //     return all
        // }
        return all.filter(category => category.parentId === parentCategoryId)
    }

    export async function getCategoryByIdAsync(categoryId: number) {
        let categories = await getAllCategoriesAsync()
        //if(!categories) throw new Error('unable to get categories')
        return categories.filter(category => category.id == categoryId)[0]
    }




    export async function checkIfCurrentUserCanSeeCategoryAsync(category:JsonProductCategory){
        if(!category.access) return false
        return category.access[await GlobalUser.getUserTypeAsync()] !== EnumDisplayPrice.Hidden
    }



    export async function getCategoryTextHtmlAsync(p:{categoryId:number, productType:string}){
        return await RequestMaker.sendWebsocketJsonRequestAsync<string>({query:'category-text', params: p}, filename)    
    }


}